module.exports = __webpack_public_path__ + "img/mdiTrayArrowDown.365f429b.svg";